export default "<p>\n  content-auto-search works!\n</p>\n"